<div class="header">
  <h3>{{'NORMAL.CUS-LIST' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading_main" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row">
    <div class="col-6">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="group"
          [options]="loadinput"
          [(ngModel)]="searchcustcode"
          filter="true"
          resetFilterOnHide="true"
          [autoDisplayFirst]="false"
          placeholder="{{'NORMAL.CUS-CODE' | translate}}"
        >
        </p-dropdown>
        <label for="addr_list">{{'NORMAL.CUS-CODE' | translate}}</label>
      </div>
    </div>
    <div class="col-6">
      <div class="form-label-group form-group">
        <input class="form-control" type="text" id="docnum" [(ngModel)]="searchdelivery"
               placeholder="{{ 'DATA.DELIVERY-ADD' | translate }}">
        <label for="documentType">{{ 'DATA.DELIVERY-ADD' | translate }}</label>
      </div>
    </div>
    <div class="col-12">
      <div class="form-label-group form-group">
        <button style="margin-left: 15px" (click)="exportDownload()" type="button"
                class=" text-center edit btn btn-primary">{{'NORMAL.EXPORT' | translate}}
        </button>
        <button (click)="create_excel($event, importpopup)" type="button"
                class=" text-center edit btn btn-primary">{{'NORMAL.IMPORT' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="optionChanged()"
  >
    <button (click)="create_cust($event, newpopup)" type="button"
            class=" text-center edit btn btn-primary">{{'NORMAL.CREATE-CUST' | translate}}</button>
  </app-custom-pagination>
  <div class="row">
    <div class="col-12  position-relative ui-sc m-t-30 ">
      <p-table class="table-responsive" [value]="cust_list" dataKey="value" *ngIf="!loading_main">
        <ng-template pTemplate="header">
          <tr class="text-center">
            <th scope="col" width="10%">{{'COMMON.TABLE.ORDER' | translate}}</th>
            <th scope="col" width="20%">{{'NORMAL.CUS-CODE' | translate}}</th>
            <th scope="col" width="30%">{{'DATA.DELIVERY-ADD' | translate}}</th>
            <th scope="col" width="30%">{{'NORMAL.EMAIL' | translate}}</th>
            <th scope="col" width="40%"> {{'NORMAL.CC' | translate}}</th>
            <th scope="col" width="25%">{{'NORMAL.TEL' | translate}}</th>
            <th scope="col" width="20%">{{'NORMAL.EDIT' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
          <tr class="ui-widget-header" *ngIf="rowGroupMetadata[rowData.value].index === rowIndex">
            <td class="text-center">{{rowIndex + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
            <td colspan="3" style="color: #01AA9D">
              <a href="#" [pRowToggler]="rowData" (click)="load_Delivery($event,rowData,rowIndex)">
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                <span>{{rowData.label}}</span>
              </a>
            </td>


            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>
              <button (click)="editcode($event, popup, rowData)" type="button"
                      class=" text-center btn btn-primary">{{'NORMAL.ADD' | translate}}</button>
              <i (click)="delete_customer($event,popupDeleteCus,rowData)" class="fa fa-trash"></i>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
          <tr *ngFor="let res of cust_list[rowIndex]['delivery']; let i = index">

            <td class="align-text-top text-center">-</td>
            <td class="align-text-top text-center">{{res.name}}</td>
            <td class="align-text-top">{{res.address}} {{res.subdistrict}}&nbsp;{{res.district}}<br>
              {{res.province}}&nbsp;{{res.postalcode}}</td>
            <td class="align-text-top widetext">
              <!--                    {{res.mail}}-->
              <ul *ngFor="let mail of res.mail;">
                <li>
                  {{mail}}
                </li>
              </ul>
            </td>
            <td class="align-text-top widetext">
              <!--              {{res.tel}}-->
              <ul *ngFor="let cc of res.cc;">
                <li>
                  {{cc}}
                </li>
              </ul>
            </td>
            <td class="align-text-top text-center text-high">
              <p *ngFor="let tel of res.tel;">

                {{tel}}

              </p>
            </td>

            <td>
              <button (click)="editdelivery($event, Edit, res)" type="button"
                      class=" text-center btn btn-outline-primary">{{'NORMAL.EDIT' | translate}}</button>
              <i (click)="delete_delivery($event,popUpDeleteDeli,res)" class="fa fa-trash danger"></i>
            </td>

          </tr>

        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row m-t-20" *ngIf="loading_main">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #popup let-modal c>
  <div class="modal-header">
    <!--<h4 class="modal-title" id="modal-basic-title">Alert</h4>-->
    <h3>{{'NORMAL.CUS-CODE' | translate}}: {{modalData.label}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model" *ngIf="!loading">
    <div class="row bg-model">
      <div class="col-12 text-center bg-model">
        <div class="dropdown-label-group text-center bg-model">
          <!--          <div *ngIf="addrlist_of_selected_cust[0].d_address">-->
          <!--          <div *ngFor="let elem of addrlist_of_selected_cust">-->
          <div class="form-label-group">
            <input class="form-control " name="delivery_c" id="d_code" [(ngModel)]="delivery_c"
                   type="text" placeholder="{{'DATA.DELIVERY-C' | translate}}">
            <label for="d_code" class="text-left">{{'DATA.DELIVERY-C' | translate}}</label>
          </div>
          <br>

          <div class="form-label-group">
            <input class="form-control " name="delivery_n" [(ngModel)]="delivery_n"
                   id="delivery_n" type="text" placeholder="{{'DATA.DELIVERY-N' | translate}}">
            <label for="delivery_n" class="text-left">{{'DATA.DELIVERY-N' | translate}}</label>
          </div>
          <br>
          <div class="form-label-group">
            <input class="form-control " name="username" [(ngModel)]="delivery_add"
                   placeholder="{{'DATA.DELIVERY-ADD' | translate}}" type="text" id="d_add">
            <label for="d_add" class="text-left">{{'DATA.DELIVERY-ADD' | translate}}</label>
          </div>
          <br>

          <table style="width: 100%">
            <tbody>
            <tr>
              <td style="width: 50%">
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_subdistrict"
                         placeholder="{{'DATA.DELIVERY-SUBDISTRICT' | translate}}" type="text" id="d_sub">
                  <label for="d_sub" class="text-left">{{'DATA.DELIVERY-SUBDISTRICT' | translate}}</label>
                </div>
              </td>
              <td style="width: 50%">
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_district"
                         placeholder="{{'DATA.DELIVERY-DISTRICT' | translate}}" type="text" id="d_dis">
                  <label for="d_dis" class="text-left">{{'DATA.DELIVERY-DISTRICT' | translate}}</label>
                </div>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_province"
                         placeholder="{{'DATA.DELIVERY-PROVINCE' | translate}}" type="text" id="d_pro">
                  <label for="d_pro" class="text-left">{{'DATA.DELIVERY-PROVINCE' | translate}}</label>
                </div>
              </td>
              <td>
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_postalcode"
                         placeholder="{{'DATA.DELIVERY-POSTALCODE' | translate}}" type="text" id="d_pos">
                  <label for="d_pos" class="text-left">{{'DATA.DELIVERY-POSTALCODE' | translate}}</label>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <br>

          <div>
            <div class="row">
              <div class="col-sm-4" style="text-align: center;border-right: 1px solid black">
                <button type="button" class="btn btn-primary m-2 m-b-10"
                        (click)="AddfelidEmail()">{{'NORMAL.ADD' | translate}} {{'NORMAL.EMAIL' | translate}}</button>
                <div *ngFor="let res of delivery_email_update; let i=index">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <input class="form-control form-control-md " name="username" [(ngModel)]="res.email"
                               placeholder="{{'NORMAL.EMAIL' | translate}}" type="text">

                      </td>
                      <td>
                        <i (click)="delete_email_list(i,res)" class="fa fa-trash danger"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
                <div *ngFor="let res of keep_email; let i=index">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <input class="form-control form-control-md " name="username" [(ngModel)]="res.email"
                               placeholder="{{'NORMAL.EMAIL' | translate}}" type="text">

                      </td>
                      <td>
                        <i (click)="delete_felidEmail(i,res)" class="fa fa-trash danger"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
              </div>
              <div class="col-sm-4" style="text-align: center;border-right: 1px solid black">
                <button type="button" class="btn btn-primary m-2 m-b-10"
                        (click)="AddfelidCC()">{{'NORMAL.ADD' | translate}} {{'NORMAL.CC' | translate}}</button>
                <div *ngFor="let res of delivery_cc_update; let i=index">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <input class="form-control form-control-md " name="username" [(ngModel)]="res.cc"
                               placeholder="{{'NORMAL.CC' | translate}}" type="text">

                      </td>
                      <td>
                        <i (click)="delete_email_list(i,res)" class="fa fa-trash danger"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
                <div *ngFor="let res of keep_cc; let i=index">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <input class="form-control form-control-md " name="username" [(ngModel)]="res.cc"
                               placeholder="{{'NORMAL.CC' | translate}}" type="text">
                      </td>
                      <td>
                        <i (click)="delete_felidCC(i,res)" class="fa fa-trash danger"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
              </div>
              <div class="col-sm-4" style="text-align: center;border-right: 1px solid black">
                <button type="button" class="btn btn-primary m-2 m-b-10"
                        (click)="AddfelidTel()">{{'NORMAL.ADD' | translate}} {{'NORMAL.TEL' | translate}}</button>
                <div *ngFor="let res of delivery_tel_update; let i=index">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <input class="form-control form-control-md " name="username" [(ngModel)]="res.tel"
                               placeholder="{{'NORMAL.TEL' | translate}}" type="text">

                      </td>
                      <td>
                        <i (click)="delete_email_list(i,res)" class="fa fa-trash danger"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
                <div *ngFor="let res of keep_tel; let i=index">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <input class="form-control form-control-md " name="username" [(ngModel)]="res.tel"
                               placeholder="{{'NORMAL.TEL' | translate}}" type="text">
                      </td>
                      <td>
                        <i (click)="delete_felidTel(i,res)" class="fa fa-trash danger"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>

  <div class="">
    <table style="width: 100%">
      <tbody>
      <tr>
        <td style="width: 50%">
          <div style="text-align: left" class="m-10 m-t-20">
            <button type="button" (click)="revertBack()"
                    class="btn  btn-outline-light redius-border"> {{'NORMAL.CLOSE' | translate}}
            </button>

          </div>
        </td>
        <td style="width: 50%">
          <div style="text-align: right" class="m-10 m-t-20">
            <button *ngIf="!loading" type="button" class=" btn btn-success redius-border"
                    (click)="add_cust_on_addrcode(modalData)">{{'NORMAL.ADD' | translate}}</button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <!--  </div>-->
</ng-template>

<ng-template #Edit let-modal>
  <div class="modal-header">
    <!--<h4 class="modal-title" id="modal-basic-title">Alert</h4>-->
    <h3>{{'NORMAL.DE-CODE' | translate}}: {{delivery_data.name}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model" *ngIf="!loading">
    <div class="row bg-model">
      <div class="col-12 text-center bg-model">
        <div class="dropdown-label-group bg-model">
          <div class="form-label-group">
            <input class="form-control " name="delivery_c" id="d_code" [(ngModel)]="delivery_c"
                   type="text" placeholder="{{'DATA.DELIVERY-C' | translate}}">
            <label for="d_code" class="text-left">{{'DATA.DELIVERY-C' | translate}}</label>
          </div>
          <br>
          <div class="form-label-group">
            <input class="form-control " name="delivery_n" [(ngModel)]="delivery_n"
                   id="delivery_n" type="text" placeholder="{{'DATA.DELIVERY-N' | translate}}">
            <label for="delivery_n" class="text-left">{{'DATA.DELIVERY-N' | translate}}</label>
          </div>
          <br>
          <div class="form-label-group">
            <input class="form-control " name="username" [(ngModel)]="delivery_add"
                   placeholder="{{'DATA.DELIVERY-ADD' | translate}}" type="text" id="d_add">
            <label for="d_add" class="text-left">{{'DATA.DELIVERY-ADD' | translate}}</label>
          </div>
          <br>
          <table style="width: 100%">
            <tbody>
            <tr>
              <td style="width: 50%">
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_subdistrict"
                         placeholder="{{'DATA.DELIVERY-SUBDISTRICT' | translate}}" type="text" id="d_sub">
                  <label for="d_sub" class="text-left">{{'DATA.DELIVERY-SUBDISTRICT' | translate}}</label>
                </div>
              </td>
              <td style="width: 50%">
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_district"
                         placeholder="{{'DATA.DELIVERY-DISTRICT' | translate}}" type="text" id="d_dis">
                  <label for="d_dis" class="text-left">{{'DATA.DELIVERY-DISTRICT' | translate}}</label>
                </div>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_province"
                         placeholder="{{'DATA.DELIVERY-PROVINCE' | translate}}" type="text" id="d_pro">
                  <label for="d_pro" class="text-left">{{'DATA.DELIVERY-PROVINCE' | translate}}</label>
                </div>
              </td>
              <td>
                <div class="form-label-group">
                  <input class="form-control " name="username" [(ngModel)]="delivery_add_postalcode"
                         placeholder="{{'DATA.DELIVERY-POSTALCODE' | translate}}" type="text" id="d_pos">
                  <label for="d_pos" class="text-left">{{'DATA.DELIVERY-POSTALCODE' | translate}}</label>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <br>


        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-sm-4" style="text-align: center;border-right: 1px solid black">
          <button type="button" class="btn btn-primary m-2 m-b-10"
                  (click)="AddfelidEmail()">{{'NORMAL.ADD' | translate}} {{'NORMAL.EMAIL' | translate}}</button>
          <div *ngFor="let res of delivery_email_update; let i=index">
            <table>
              <tbody>
              <tr>
                <td>
                  <input class="form-control form-control-md " name="username" [(ngModel)]="res.email"
                         placeholder="{{'NORMAL.EMAIL' | translate}}" type="text">

                </td>
                <td>
                  <i (click)="delete_email_list(i,res)" class="fa fa-trash danger"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
          </div>
          <div *ngFor="let res of keep_email; let i=index">
            <table>
              <tbody>
              <tr>
                <td>
                  <input class="form-control form-control-md " name="username" [(ngModel)]="res.email"
                         placeholder="{{'NORMAL.EMAIL' | translate}}" type="text">

                </td>
                <td>
                  <i (click)="delete_felidEmail(i,res)" class="fa fa-trash danger"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
            <!--                             <input class="form-control form-control-md " name="username" [(ngModel)]="res.email"-->
            <!--                             placeholder="{{'NORMAL.EMAIL' | translate}}" type="text"><br>-->
          </div>
        </div>
        <div class="col-sm-4" style="text-align: center;border-right: 1px solid black">
          <button type="button" class="btn btn-primary m-2 m-b-10"
                  (click)="AddfelidCC()">{{'NORMAL.ADD' | translate}} {{'NORMAL.CC' | translate}}</button>
          <div *ngFor="let res of delivery_cc_update; let i=index">
            <table>
              <tbody>
              <tr>
                <td>
                  <input class="form-control form-control-md " name="username" [(ngModel)]="res.cc"
                         placeholder="{{'NORMAL.CC' | translate}}" type="text">

                </td>
                <td>
                  <i (click)="delete_cc_list(i,res)" class="fa fa-trash danger"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
          </div>
          <div *ngFor="let res of keep_cc; let i=index">
            <table>
              <tbody>
              <tr>
                <td>
                  <input class="form-control form-control-md " name="username" [(ngModel)]="res.cc"
                         placeholder="{{'NORMAL.CC' | translate}}" type="text">
                </td>
                <td>
                  <i (click)="delete_felidCC(i,res)" class="fa fa-trash danger"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <br>

          </div>
        </div>
        <div class="col-sm-4" style="text-align: center;border-right: 1px solid black">
          <button type="button" class="btn btn-primary m-2 m-b-10"
                  (click)="AddfelidTel()">{{'NORMAL.ADD' | translate}} {{'NORMAL.TEL' | translate}}</button>
          <div *ngFor="let res of delivery_tel_update; let i=index">
            <table>
              <tbody>
              <tr>
                <td>
                  <input class="form-control form-control-md " name="username" [(ngModel)]="res.tel"
                         placeholder="{{'NORMAL.TEL' | translate}}" type="text">

                </td>
                <td>
                  <i (click)="delete_tel_list(i,res)" class="fa fa-trash danger"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
          </div>
          <div *ngFor="let res of keep_tel; let i=index">
            <table>
              <tbody>
              <tr>
                <td>
                  <input class="form-control form-control-md " name="username" [(ngModel)]="res.tel"
                         placeholder="{{'NORMAL.TEL' | translate}}" type="text">
                </td>
                <td>
                  <i (click)="delete_felidTel(i,res)" class="fa fa-trash danger"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <br>

          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
  <div class="">
    <table style="width: 100%">
      <tbody>
      <tr>
        <td style="width: 50%">
          <div class="text-left m-10 m-t-20 m-b-20" style="text-align: left;">
            <button type="button" (click)="revertBack()"
                    class="btn btn-outline-danger redius-border"> {{'NORMAL.CLOSE' | translate}}
            </button>
          </div>
        </td>
        <td style="width: 50%">
          <div class="text-right m-10" style="text-align: right">
            <button type="button" class=" btn btn-success redius-border"
                    (click)="update_delivery(delivery_data)">{{'NORMAL.EDIT' | translate}}</button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</ng-template>


<ng-template class="whatever" #newpopup let-modal>
  <div class="modal-header">
    <!--<h4 class="modal-title" id="modal-basic-title">Alert</h4>-->
    <h3>Create new customer code</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model">
    <div class="row bg-model">
      <div class="col-12 text-center bg-model">
        <div class="form-group">
          <div class="form-label-group">
            <input class="form-control " name="email" [(ngModel)]="newcustcode"
                   placeholder="New cust. code" type="text">
            <label>New cust. code</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center form-label-group">
        <input class="form-control" name="newcus" [(ngModel)]="newcustname"
               id="newcus" placeholder="Customer name" type="email">
        <label for="newcus">Customer name</label>
      </div>
    </div>
    <div class="row">
      <div class="col-12 space text-center form-label-group d-none">
        <input class="form-control " name="username" [(ngModel)]="newcontactname"
               placeholder="Contact name" type="Tel">
        <label>Contact name</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide redius-border"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" (click)="save_new_customer()"
              class="btn btn-dv btn-wide redius-border"> {{'TEXT.SAVE' | translate}}
      </button>
    </div>
  </div>
</ng-template>


<ng-template class="" #popUpDeleteDeli let-modal>
  <div class="modal-header">
    <h3>{{'TEXT.CONFIRM-DELETE-DELI' | translate}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model">
    <div class=" center ml-3">
      <span>
        - {{deleteDelivery.name}}
      </span>
    </div>

  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide redius-border"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" (click)="confirm_deleteDeli()"
              class="btn btn-dv btn-wide redius-border"> {{'TEXT.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template class="" #popupDeleteCus let-modal>
  <div class="modal-header">
    <h3>{{'TEXT.CONFIRM-DELETE-CUS' | translate}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model">
    <div class=" center ml-3">
      <span>
        - {{deleteCustomer.label}}
      </span>
    </div>

  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide redius-border"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" (click)="confirm_deleteCus()"
              class="btn btn-dv btn-wide redius-border"> {{'TEXT.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template class="whatever" #importpopup let-modal>
  <div class="modal-header">
    <h3>Upload Excel list code :</h3>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div>
    <div id="drop-area">
    <div appDragDrop (files)="filesDropped($event)">
      <form style="text-align: center">
        <input type="file" id="fileElem" accept=".xlsx,.xls" (change)="handleFiles($event)">
        <label class="button text-center dropDrang-area" for="fileElem" *ngIf="keepexcel.length === 0">Browse or Drop files here</label>
        <div *ngIf="keepexcel.length > 0">
          <div *ngFor="let file of keepexcel">
            <i class="fas fa-file-excel" style="font-size: 24px;"></i>
            <label *ngIf="!updateMessage" class="button text-center dropDrang-area" for="fileElem">{{ file.name }}</label>
            <label *ngIf="updateMessage">{{ file.name }}</label>
          </div>
        </div>
            <div class="row m-t-20" *ngIf="loading">
                <div class="col-12 text-center">
                    <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
                </div>
            </div>
      </form>
    </div>
    </div>
    <div style="margin-left: 25px" *ngIf="errorMessage">
      <p style="color: red ; margin-top: -25px ; margin-bottom: 30px">{{errorMessage}}</p>
<!--      <p style="color: #27cb00 ; margin-top: -25px ; margin-bottom: 30px">{{updateMessage}}</p>-->
    </div>
        <div style="margin-left: 25px" *ngIf="updateMessage">
<!--      <p style="color: red ; margin-top: -25px ; margin-bottom: 30px">{{errorMessage}}</p>-->
      <p style="color: #27cb00 ; margin-top: -25px ; margin-bottom: 30px">{{updateMessage}}</p>
    </div>
  </div>
  <div class="modal-footer" >
    <div class="col-6 text-left">
      <button *ngIf="!updateMessage" type="button" class="btn btn-dv btn-danger btn-wide redius-border"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button  *ngIf="!updateMessage" type="button" (click)="saveImport()"
              class="btn btn-dv btn-wide redius-border">{{'TEXT.SAVE' | translate}}
      </button>
      <button  *ngIf="updateMessage" type="button" (click)="revertBack()"
              class="btn btn-dv btn-wide redius-border">{{'COMMON.DONE' | translate}}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/link-code/link-code.component.html